(() => {
  const mapping = JSON.parse(document.getElementById('lfa-media-overrides')?.textContent || '{}');
  const updateImage = (image) => {
    const source = `${image.getAttribute('src') || ''} ${image.getAttribute('srcset') || ''}`;
    const match = Object.keys(mapping).find((key) => source.includes(key));
    if (!match) return;
    image.src = mapping[match];
    image.removeAttribute('srcset');
    const zoom = image.closest('.media-gallery__link');
    if (zoom) {
      zoom.href = mapping[match];
      zoom.dataset.pswpWidth = match.startsWith('0952') ? '1122' : '1254';
      zoom.dataset.pswpHeight = match.startsWith('0952') ? '1402' : '1254';
    }
  };
  const labelGallery = (gallery) => {
    gallery.querySelectorAll('.media-gallery__arrow--prev').forEach((button) => {
      button.setAttribute('aria-label', gallery.dataset.previousLabel || '');
    });
    gallery.querySelectorAll('.media-gallery__arrow--next').forEach((button) => {
      button.setAttribute('aria-label', gallery.dataset.nextLabel || '');
    });
  };
  document.querySelectorAll('.media-gallery[data-previous-label]').forEach(labelGallery);
  document.querySelectorAll('img').forEach(updateImage);
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes' && record.target.matches('img')) updateImage(record.target);
      record.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        const gallery = node.closest('.media-gallery[data-previous-label]');
        if (gallery) labelGallery(gallery);
        node.querySelectorAll('.media-gallery[data-previous-label]').forEach(labelGallery);
        if (node.matches('img')) updateImage(node);
        node.querySelectorAll('img').forEach(updateImage);
      });
    });
  }).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset']});
  // The theme moves the filter drawer outside its collection element.
  // Delegate its reset control so it remains usable after each filter refresh.
  document.addEventListener('click', (event) => {
    const reset = event.target.closest('.collection-sidebar__draw-actions button.js-filter-trigger[data-url]');
    if (!reset || reset.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(reset.dataset.url);
  }, true);
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-lfa-remove-kiwi]');
    if (!chip) return;
    const url = new URL(chip.href);
    const param = chip.dataset.lfaRemoveKiwi;
    const values = url.searchParams.getAll(param).filter((value) => value.toLowerCase() !== 'kiwi');
    url.searchParams.delete(param);
    values.forEach((value) => url.searchParams.append(param, value));
    chip.href = url.href;
  }, true);
  document.addEventListener('change', (event) => {
    const group = event.target.closest('[data-lfa-color-group]');
    if (!group || event.target.type !== 'checkbox') return;
    group.querySelectorAll('input[type="checkbox"]').forEach((input) => { input.checked = event.target.checked; });
  }, true);
})();
